module.exports = __webpack_public_path__ + "media/images/illustrations/donkey-lock-35895f9ae96f9f59303ebb23be20be7a.png";